import Vue from 'vue';

export default function() {
	Vue.$ofsCrud.addResource({
		name: 'document',
		pluralName: 'documents',
		transport: 'davinci',
		options: {
			namespaced: true
		}
	});
}
